import { Flex, useMantineTheme } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { ActionBar, Button, Icon, Text, Time } from '@feathr/components';
import { TimeFormat } from '@feathr/hooks';
import { useUser } from '@feathr/report_components';

import { useDonationFormBuilder } from './useDonationFormBuilder';

function DonationFormBuilderActionBar(): JSX.Element {
  const { t } = useTranslation();
  const {
    spacing: { '2': gap },
  } = useMantineTheme();
  const { lastSaved, handleSave, isDirty, isValid } = useDonationFormBuilder();
  const user = useUser();

  return (
    <ActionBar
      left={
        <Flex gap={gap}>
          <Text.DefaultSemibold>{t('Last saved:')}</Text.DefaultSemibold>
          <Time
            format={TimeFormat.longDateTime}
            showTimezone={false}
            timestamp={lastSaved ?? t('Never')}
            timezone={user.get('timezone')}
          />
        </Flex>
      }
      right={
        <Button
          disabled={!isDirty || !isValid}
          onClick={handleSave}
          prefix={<Icon.Save />}
          type={'primary'}
        >
          {t('Save changes')}
        </Button>
      }
      usePortal={true}
    />
  );
}

export default observer(DonationFormBuilderActionBar);
